import { createContext, useContext } from 'react';

// ? a sub-view replaces the whole step, so it takes over the sheet back button
export const MfaSetupSheetContext = createContext<{
  setSubView: (subView: { onBack: () => void } | null) => void;
}>({
  setSubView: () => void 0,
});

export function useMfaSetupSheet() {
  return useContext(MfaSetupSheetContext);
}
